import { createRouter, createWebHistory } from "vue-router";
import { useStore } from "@/store";

const routes = [
  {
    path: "/",
    name: "home",
    component: () => import(/* webpackChunkName: "home-page" */ "../views/pages/Home.vue"),
  },

  {
    path: "/login",
    name: "login",
    component: () => import(/* webpackChunkName: "login-page" */ "../views/auth/Login.vue"),
  },

  {
    path: "/packages",
    name: "packages",
    component: () => import(/* webpackChunkName: "packages-page" */ "../views/areas/packages/Index.vue"),
  },

  {
    path: "/verify-login/:token",
    name: "verify-login",
    component: () => import(/* webpackChunkName: "verify-login-page" */ "../views/auth/VerifyLogin.vue"),
  },

  {
    path: "/dashboard",
    name: "dashboard",
    component: () => import(/* webpackChunkName: "areas-dashboard-index" */ "../views/areas/dashboard/Index.vue"),
    meta: {
      auth: true,
    },
  },

  {
    path: "/profile",
    name: "profile",
    component: () => import(/* webpackChunkName: "profile-page" */ "../views/areas/profile/Index.vue"),
    meta: {
      auth: true,
    },
  },

  {
    path: "/resources",
    name: "resourcesindex",
    component: () => import(/* webpackChunkName: "resources-index" */ "../views/areas/resources/Index.vue"),
    meta: {
      auth: true,
    },
  },

  {
    path: "/events",
    name: "eventsindex",
    component: () => import(/* webpackChunkName: "events-index" */ "../views/areas/events/Index.vue"),
    meta: {
      auth: true,
    },
  },


  {
    path: "/faqs",
    name: "faqsindex",
    component: () => import(/* webpackChunkName: "faqs-index" */ "../views/areas/faqs/Index.vue"),
    meta: {
      auth: true,
    },
  },

  {
    path: "/links",
    name: "linksindex",
    component: () => import(/* webpackChunkName: "links-index" */ "../views/areas/links/Index.vue"),
    meta: {
      auth: true,
    },
  },

  {
    path: "/employees",
    name: "employeesindex",
    component: () => import(/* webpackChunkName: "employees-index" */ "../views/areas/employees/Index.vue"),
    meta: {
      auth: true,
    },
  },

  {
    path: "/employees/:id",
    name: "employeesview",
    component: () => import(/* webpackChunkName: "employees-view" */ "../views/areas/employees/View.vue"),
    meta: {
      auth: true,
    },
  },

  {
    path: "/employees/create",
    name: "employeescreate",
    component: () => import(/* webpackChunkName: "employees-create" */ "../views/areas/employees/Create.vue"),
    meta: {
      auth: true,
    },
  },

  {
    path: "/support-tickets/create",
    name: "support-tickets-create",
    component: () =>
      import(/* webpackChunkName: "support-tickets-create" */ "../views/areas/support-tickets/Create.vue"),
    meta: {
      auth: true,
    },
  },
];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
});

router.beforeEach((to, from, next) => {
  const store = useStore();
  const loggedInUser = store.user;

  if (to.matched.some((record) => record.meta.auth) && !loggedInUser) {
    next("/login");
    return;
  }

  if (to.path === "/login" || to.path === "/") {
    if (loggedInUser) {
      next("/dashboard");
    }
  }

  const menuToggle = document.getElementById("collapsableNav");
  const bsCollapse = new bootstrap.Collapse(menuToggle, {
    toggle: false,
  });
  bsCollapse.hide();

  next();
});

export default router;
